import CustomIcon from "../CustomIcon";

const Loader = () => {
    // const [src, setSrc] = React.useState("https://cdn0030.qrcodechimp.com/qr/5d526d2d65558649073a8ee2/ld/1566401419h23sf7.png?v=1760355018478");
    const src = window.logo;

    // React.useEffect(() => {
    //     async function fetchLogo() {
    //         try {
    //             const res = await getHostDomainImagesApi({ cmd: "getHostDomainImages" });
    //             console.log(res);
    //             if (res?.data?.logo) {
    //                 setSrc(res.data.logo);
    //             }
    //         } catch (err) {
    //             console.error("Error fetching host domain images:", err);
    //         }

    //     }

    //     fetchLogo();
    // }, [src]);

    return (
        <div className="flex justify-center items-center" style={{ backgroundColor: "#f3f4f6", opacity: "0.85", height: "inherit", width: "inherit", zIndex: 1500, border: "0", padding: "0", }}>
            <CustomIcon
                id="loader-logo"
                src={src}
                alt="loader-logo"
            />
        </div>
    )
};

export default Loader;